<template>
  <Card class="moreInfo">
    <el-tabs v-model="curIndex" @tab-click="handleTabClick">
      <el-tab-pane name="filterRecord" label="筛查记录">
        <filter-record :dataSource="dataSource" :info="info" @success="success" />
      </el-tab-pane>
      <el-tab-pane
        v-for="item in list"
        :key="item.id"
        :name="item.id + ''"
        :label="item.name"
      >
        <more-info-wrap style="padding: 16px;" :ref="'module' + item.id" v-if="item.type === '业务' && item.businesses && item.businesses.length" :info="info" :bus="item.businesses[0]" />
        <more-info-module style="padding: 16px;" :ref="'module' + item.id" v-if="item.type === '目录'" :dataSource="item.child_modules" :info="info" @changeIndex="changeIndex($event, item.id)"/>
      </el-tab-pane>
      <el-tab-pane name="filterTreat" label="管理方案">
        <treat-info ref="treatInfo" :info="info"></treat-info>
      </el-tab-pane>
      <el-tab-pane name="filterEvent" label="活动记录">
        <event-info ref="eventInfo" :info="info"></event-info>
      </el-tab-pane>
    </el-tabs>
  </Card>
</template>
<script>

import filterRecord from "../components/filterRecord.vue";
import treatInfo from "../components/treatInfo.vue";
import moreInfoModule from "../components/moreInfoModule.vue";
import moreInfoWrap from "../components/moreInfoWrap.vue";
import eventInfo from "../components/eventInfo.vue";
import {
  getPatientModuleListApi,
} from "../../../api/config";
export default {
  components: {
    filterRecord,
    treatInfo,
    eventInfo,
    moreInfoModule,
    moreInfoWrap
  },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      default: "",
    },
  },
  provide: {
    moreInfoType: 'filter'
  },
  data() {
    return {
      curIndex: "filterRecord",
      list: [],
    };
  },
  mounted() {
    this.getModuleList();
  },
  methods: {
    success() {
      this.$emit('success');
    },
    handleTabClick() {
      if (this.curIndex === 'filterRecord') {
        // this.getPatientRecord();
      } else if (this.curIndex === 'filterTreat') {
        this.$nextTick(() => {
          this.$refs.treatInfo.getTreatList();
          this.$refs.treatInfo.calcWidth();
        })
      } else if (this.curIndex === 'filterEvent') {
          this.$refs.eventInfo.getUserLog();
      } else {
        this.$refs['module' + this.curIndex][0].getList();
        // this.$refs['module' + this.curIndex][0].getTrend();
      }
    },
    getModuleList() {
      getPatientModuleListApi(this.info.patient_id, 0).then((res) => {
        if (res.code === 0) {
          this.list = (res.data.default_module || []).map(d => {
            (d.child_modules || []).forEach(c => c.curIndex = 0)
            return d;
          });
        }
      });
    },
    changeIndex({p, c}, moduleId) {
      const module = this.list.find(l => l.id === moduleId);
      this.$set(module.child_modules[p], 'curIndex', c);
    }
  },
};
</script>